<div class="d-flex justify-content-center align-items-center flex-column ">
  <h1>404</h1>
  <h2>PAGE NOT FOUND</h2>
</div>